/**
 * Error Interceptor
 *
 * Why: Centralize error handling for all API requests
 * What: Handles common errors (401,403,500,network errors)
 * Benefits: Constant error handling. automatic token refresh,user notifications
 */

import type { AxiosError, InternalAxiosRequestConfig } from "axios";
import { logger } from "../../../utils";

/**
 * Queue of failed requests waiting for token refresh
 * Why: Retry failed requests after token is refreshed
 */

/**
 * Handle response errors
 */
export const errorResponseInterceptor = async (
  error: AxiosError,
): Promise<unknown> => {
  const originalRequest = error.config as InternalAxiosRequestConfig & {
    _retry?: boolean;
  };

  // skip error handling if requested
  if (
    (originalRequest as unknown as Record<string, unknown>).skipErrorHandler
  ) {
    return Promise.reject(error);
  }

  // =======================
  // 🔹 Handle 401 Unauthorized
  // =======================

  if (error.response?.status === 401 && !originalRequest._retry) {
    logger.warn("401 Unauthorized - Attempting token");
    window.location.href = "/login";
    return Promise.reject(error);
  }
  return Promise.reject(error);
};
